import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconPlus, IconSearch } from "@tabler/icons-react";
import { debounce } from "lodash";
import { ConfirmDialog } from "components";
import { LangConstant } from "const";
import { useDeletePosition } from "hooks";

const Heading = ({
  selectedPositions,
  units,
  departments,
  searchInput,
  unitId,
  departmentId,
  onClickCreatePosition,
  onChangeSearchInput,
  onChangeUnit,
  onChangeDepartment,
  onDeletePositionSuccess,
}) => {
  const { t: getLabel } = useTranslation();
  const { deletePosition } = useDeletePosition();

  const [isOpenDeleteConfirmDialog, setIsOpenDeleteConfirmDialog] = useState(false);

  const handleChangeSearchInput = debounce(onChangeSearchInput, 500);

  const handleToggleOpenDialog = () => {
    setIsOpenDeleteConfirmDialog(!isOpenDeleteConfirmDialog);
  };

  const handleDeletePositions = () => {
    const selectedPositionIdList = selectedPositions.map(position => position.positionId);
    deletePosition({
      positionIds: selectedPositionIdList,
      onClose: handleToggleOpenDialog,
      onSuccess: () => onDeletePositionSuccess(null, 1),
    });
  };

  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div className="d-flex gap-2">
        <div className="input-group" style={{ width: 400 }}>
          <input
            type="text"
            className="form-control"
            placeholder={getLabel("P_SEARCH_POSITION")}
            onChange={handleChangeSearchInput}
            defaultValue={searchInput}
          />
          <span className="input-group-text">
            <IconSearch size={16} />
          </span>
        </div>
        <div style={{ width: 200 }}>
          <select
            className="form-select"
            value={unitId}
            onChange={onChangeUnit}
          >
            <option value="">{getLabel("TXT_CHOOSE_UNIT")}</option>
            {units.map(unit => (
              <option value={unit.unitId} key={unit.unitId}>
                {unit.unitName}
              </option>
            ))}
          </select>
        </div>
        <div style={{ width: 200 }}>
          <select
            className="form-select"
            value={departmentId}
            onChange={onChangeDepartment}
            disabled={!Boolean(unitId)}
          >
            <option value="">{getLabel("TXT_CHOOSE_DEPARTMENT")}</option>
            {departments.map(department => (
              <option value={department.departmentId} key={department.departmentId}>
                {department.departmentName}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-2">
        <button
          className="btn btn-danger"
          style={{ height: 40 }}
          disabled={selectedPositions.length === 0}
          onClick={handleToggleOpenDialog}
        >
          {getLabel("L_DELETE")}
        </button>
        <button
          className="btn btn-primary"
          style={{ height: 40 }}
          onClick={onClickCreatePosition}
        >
          <IconPlus size={16} className="me-1" />
          {getLabel("L_CREATE")}
        </button>

        <ConfirmDialog
          open={isOpenDeleteConfirmDialog}
          title={getLabel(LangConstant.TXT_CONFIRM_DELETE_POSITION)}
          onDeny={handleToggleOpenDialog}
          onConfirm={handleDeletePositions}
        />
      </div>
    </div>
  );
};

export default Heading;
